import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { useState } from "react";

// Dummy projects data (should match Home.tsx)
const PROJECTS = [
  {
    id: 1,
    name: "DeFi Protocol",
    description: "Building next-gen DeFi infrastructure",
    tech: ["Solidity", "React", "Node.js"],
    applied: 12,
    stars: 156
  },
  {
    id: 2,
    name: "NFT Marketplace",
    description: "Decentralized marketplace for digital assets",
    tech: ["TypeScript", "Next.js", "Hardhat"],
    applied: 8,
    stars: 89
  },
  {
    id: 3,
    name: "DAO Tools",
    description: "Governance tools for DAOs",
    tech: ["React", "Python", "Solidity"],
    applied: 15,
    stars: 234
  }
];

export default function ProjectDetails() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [applied, setApplied] = useState(false);
  const project = PROJECTS.find(p => p.id === Number(id));

  if (!project) return <div className="p-8 text-center">Project not found</div>;

  const handleApply = () => {
    if (user) {
      setApplied(true);
      // You can show a form/modal here instead
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle>{project.name}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="mb-2 text-muted-foreground">{project.description}</div>
          <div className="mb-2 flex gap-2 flex-wrap">
            {project.tech.map(tech => (
              <span key={tech} className="bg-secondary rounded-full px-3 py-1 text-xs">{tech}</span>
            ))}
          </div>
          <div className="mb-4 text-xs text-muted-foreground">{project.applied} applied • {project.stars} stars</div>
          {applied ? (
            <div className="text-green-600 font-semibold">Application submitted!</div>
          ) : (
            <Button className="w-full" onClick={handleApply}>Apply</Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
} 